(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["content-column"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.content-column').forEach((slide) => {
      const destinationUrl = slide.getAttribute('data-destination-url');
      if (destinationUrl) {
        const linkWrapper = document.createElement('a');
        linkWrapper.href = destinationUrl;
        while (slide.firstChild) {
          linkWrapper.appendChild(slide.firstChild);
        }
        slide.appendChild(linkWrapper);
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
